// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file trade/v1/booking_events.proto (package trade.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Booking, BookingStatus } from "./booking_pb.js";
import { file_trade_v1_booking } from "./booking_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file trade/v1/booking_events.proto.
 */
export const file_trade_v1_booking_events: GenFile = /*@__PURE__*/
  fileDesc("Ch10cmFkZS92MS9ib29raW5nX2V2ZW50cy5wcm90bxIIdHJhZGUudjEi+wIKDEJvb2tpbmdFdmVudBIwCgdjcmVhdGVkGAEgASgLMh0udHJhZGUudjEuQm9va2luZ0NyZWF0ZWRFdmVudEgAEjAKB3VwZGF0ZWQYAiABKAsyHS50cmFkZS52MS5Cb29raW5nVXBkYXRlZEV2ZW50SAASMAoHZGVsZXRlZBgDIAEoCzIdLnRyYWRlLnYxLkJvb2tpbmdEZWxldGVkRXZlbnRIABIuCgZvcGVuZWQYBSABKAsyHC50cmFkZS52MS5Cb29raW5nT3BlbmVkRXZlbnRIABIwCgdzaGlwcGVkGAYgASgLMh0udHJhZGUudjEuQm9va2luZ1NoaXBwZWRFdmVudEgAEjQKCWNvbXBsZXRlZBgHIAEoCzIfLnRyYWRlLnYxLkJvb2tpbmdDb21wbGV0ZWRFdmVudEgAEi4KBnZvaWRlZBgIIAEoCzIcLnRyYWRlLnYxLkJvb2tpbmdWb2lkZWRFdmVudEgAQgcKBWV2ZW50SgQIBBAFIjkKE0Jvb2tpbmdDcmVhdGVkRXZlbnQSIgoHYm9va2luZxgBIAEoCzIRLnRyYWRlLnYxLkJvb2tpbmcibgoTQm9va2luZ1VwZGF0ZWRFdmVudBIrChBwcmV2aW91c19ib29raW5nGAEgASgLMhEudHJhZGUudjEuQm9va2luZxIqCg91cGRhdGVkX2Jvb2tpbmcYAiABKAsyES50cmFkZS52MS5Cb29raW5nIjkKE0Jvb2tpbmdEZWxldGVkRXZlbnQSIgoHYm9va2luZxgBIAEoCzIRLnRyYWRlLnYxLkJvb2tpbmciagoSQm9va2luZ09wZW5lZEV2ZW50EiIKB2Jvb2tpbmcYASABKAsyES50cmFkZS52MS5Cb29raW5nEjAKD3ByZXZpb3VzX3N0YXR1cxgCIAEoDjIXLnRyYWRlLnYxLkJvb2tpbmdTdGF0dXMiawoTQm9va2luZ1NoaXBwZWRFdmVudBIiCgdib29raW5nGAEgASgLMhEudHJhZGUudjEuQm9va2luZxIwCg9wcmV2aW91c19zdGF0dXMYAiABKA4yFy50cmFkZS52MS5Cb29raW5nU3RhdHVzIm0KFUJvb2tpbmdDb21wbGV0ZWRFdmVudBIiCgdib29raW5nGAEgASgLMhEudHJhZGUudjEuQm9va2luZxIwCg9wcmV2aW91c19zdGF0dXMYAiABKA4yFy50cmFkZS52MS5Cb29raW5nU3RhdHVzImoKEkJvb2tpbmdWb2lkZWRFdmVudBIiCgdib29raW5nGAEgASgLMhEudHJhZGUudjEuQm9va2luZxIwCg9wcmV2aW91c19zdGF0dXMYAiABKA4yFy50cmFkZS52MS5Cb29raW5nU3RhdHVzQi9aLXBhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLXRyYWRlL2FwaS92MTt0cmFkZV92MWIIZWRpdGlvbnNw6Ac", [file_trade_v1_booking]);

/**
 * @generated from message trade.v1.BookingEvent
 */
export type BookingEvent = Message<"trade.v1.BookingEvent"> & {
  /**
   * @generated from oneof trade.v1.BookingEvent.event
   */
  event: {
    /**
     * @generated from field: trade.v1.BookingCreatedEvent created = 1;
     */
    value: BookingCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: trade.v1.BookingUpdatedEvent updated = 2;
     */
    value: BookingUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: trade.v1.BookingDeletedEvent deleted = 3;
     */
    value: BookingDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: trade.v1.BookingOpenedEvent opened = 5;
     */
    value: BookingOpenedEvent;
    case: "opened";
  } | {
    /**
     * @generated from field: trade.v1.BookingShippedEvent shipped = 6;
     */
    value: BookingShippedEvent;
    case: "shipped";
  } | {
    /**
     * @generated from field: trade.v1.BookingCompletedEvent completed = 7;
     */
    value: BookingCompletedEvent;
    case: "completed";
  } | {
    /**
     * @generated from field: trade.v1.BookingVoidedEvent voided = 8;
     */
    value: BookingVoidedEvent;
    case: "voided";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message trade.v1.BookingEvent.
 * Use `create(BookingEventSchema)` to create a new message.
 */
export const BookingEventSchema: GenMessage<BookingEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking_events, 0);

/**
 * @generated from message trade.v1.BookingCreatedEvent
 */
export type BookingCreatedEvent = Message<"trade.v1.BookingCreatedEvent"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message trade.v1.BookingCreatedEvent.
 * Use `create(BookingCreatedEventSchema)` to create a new message.
 */
export const BookingCreatedEventSchema: GenMessage<BookingCreatedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking_events, 1);

/**
 * @generated from message trade.v1.BookingUpdatedEvent
 */
export type BookingUpdatedEvent = Message<"trade.v1.BookingUpdatedEvent"> & {
  /**
   * @generated from field: trade.v1.Booking previous_booking = 1;
   */
  previousBooking?: Booking;

  /**
   * @generated from field: trade.v1.Booking updated_booking = 2;
   */
  updatedBooking?: Booking;
};

/**
 * Describes the message trade.v1.BookingUpdatedEvent.
 * Use `create(BookingUpdatedEventSchema)` to create a new message.
 */
export const BookingUpdatedEventSchema: GenMessage<BookingUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking_events, 2);

/**
 * @generated from message trade.v1.BookingDeletedEvent
 */
export type BookingDeletedEvent = Message<"trade.v1.BookingDeletedEvent"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message trade.v1.BookingDeletedEvent.
 * Use `create(BookingDeletedEventSchema)` to create a new message.
 */
export const BookingDeletedEventSchema: GenMessage<BookingDeletedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking_events, 3);

/**
 * @generated from message trade.v1.BookingOpenedEvent
 */
export type BookingOpenedEvent = Message<"trade.v1.BookingOpenedEvent"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;

  /**
   * @generated from field: trade.v1.BookingStatus previous_status = 2;
   */
  previousStatus: BookingStatus;
};

/**
 * Describes the message trade.v1.BookingOpenedEvent.
 * Use `create(BookingOpenedEventSchema)` to create a new message.
 */
export const BookingOpenedEventSchema: GenMessage<BookingOpenedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking_events, 4);

/**
 * @generated from message trade.v1.BookingShippedEvent
 */
export type BookingShippedEvent = Message<"trade.v1.BookingShippedEvent"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;

  /**
   * @generated from field: trade.v1.BookingStatus previous_status = 2;
   */
  previousStatus: BookingStatus;
};

/**
 * Describes the message trade.v1.BookingShippedEvent.
 * Use `create(BookingShippedEventSchema)` to create a new message.
 */
export const BookingShippedEventSchema: GenMessage<BookingShippedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking_events, 5);

/**
 * @generated from message trade.v1.BookingCompletedEvent
 */
export type BookingCompletedEvent = Message<"trade.v1.BookingCompletedEvent"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;

  /**
   * @generated from field: trade.v1.BookingStatus previous_status = 2;
   */
  previousStatus: BookingStatus;
};

/**
 * Describes the message trade.v1.BookingCompletedEvent.
 * Use `create(BookingCompletedEventSchema)` to create a new message.
 */
export const BookingCompletedEventSchema: GenMessage<BookingCompletedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking_events, 6);

/**
 * @generated from message trade.v1.BookingVoidedEvent
 */
export type BookingVoidedEvent = Message<"trade.v1.BookingVoidedEvent"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;

  /**
   * @generated from field: trade.v1.BookingStatus previous_status = 2;
   */
  previousStatus: BookingStatus;
};

/**
 * Describes the message trade.v1.BookingVoidedEvent.
 * Use `create(BookingVoidedEventSchema)` to create a new message.
 */
export const BookingVoidedEventSchema: GenMessage<BookingVoidedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking_events, 7);

